<div class="app-v-select v-control position-relative" style="display: flex;padding-top: 1px;"
  [ngStyle]="{height: panelHeight}"
  [ngClass]="customClass" [class.v-disabled]="_disabled">
  <input type="text" class="border-0 bg-transparent"
    [style.width]="showClearButton && _displayText && !_disabled ? 'calc(100% - 46px)' : 'calc(100% - 18px)'"
    style="height: 100%;" aria-label="Number" matInput
    [value]="_displayText" [ngClass]="_class" #input (click)="onInputClick()" (blur)="blurChange()" (input)="inputChange()" (keydown)="onKeyDown($event)"
    [matAutocomplete]="auto" [disabled]="_disabled"> <!-- (change)="_valueChange($event)" -->
  <button *ngIf="showClearButton && _displayText && !_disabled" type="button" class="clear-btn position-absolute h-100 d-inline-flex"
    style="right: 24px;top: 0;width: 20px;height: 100%;padding: 0;align-items: center;justify-content: center;z-index: 1;background: transparent;border: none;outline: none;cursor: pointer;vertical-align: middle;"
    (click)="clearInput()">
    <mat-icon style="font-size: 16px;width: 16px;height: 16px;">clear</mat-icon>
  </button> 
  <div (click)="openPanel()" class="h-100 position-absolute cursor-pointer d-inline-flex" style="right: 6px;">
    <div class="mat-select-arrow m-auto bottom-0 top-0"></div>
  </div>
  
  <!-- <mat-icon style="position: absolute;right: 0px;top: 3px;" matSuffix>keyboard_arrow_down</mat-icon>  -->
  <mat-autocomplete [class]="panelClass" [panelWidth]="panelFitContent?'fit-content':'1000'" (optionSelected)="optSelected($event)"
    [ngStyle]="{height: panelHeight}" #auto="matAutocomplete">
    <div style="overflow-y: auto;height: 100%;position: relative;" (scrollend)="panelScroll($event)">
      <div *ngIf="lodingPage" style="position: absolute;height: 100%; width: 100%;background-color: #ddd;">
        讀取中...
      </div>
      <mat-option *ngFor="let item of filteredOptions | async" [value]="item[valueField]" [ngStyle]="{height: panelHeight}">
        <!-- {{item.text}} -->
        <ng-container *ngIf="displayTmp;else defaultTmp">
          <ng-container *ngTemplateOutlet="displayTmp;context:{$implicit:item}"></ng-container>
        </ng-container>
        <ng-template #defaultTmp>{{item!=undefined&&item!=null?item[textField]:''}}</ng-template>
      </mat-option>
    </div>
  </mat-autocomplete>
</div>
